export const categories = [
  {
    slug: 'japan-drama',
    name: '日剧',
    icon: 'ri-tv-line',
    description: '最新日本电视剧推荐、剧情解析与收视动态',
    color: 'primary',
  },
  {
    slug: 'korea-drama',
    name: '韩剧',
    icon: 'ri-movie-line',
    description: '热门韩剧追踪、OST推荐与演员专访',
    color: 'accent',
  },
  {
    slug: 'japan-movie',
    name: '日本电影',
    icon: 'ri-film-line',
    description: '日本电影新片速递、经典回顾与影评分析',
    color: 'secondary',
  },
  {
    slug: 'korea-movie',
    name: '韩国电影',
    icon: 'ri-clapperboard-line',
    description: '韩国电影票房排行、导演访谈与深度影评',
    color: 'primary',
  },
  {
    slug: 'kpop',
    name: 'K-POP',
    icon: 'ri-music-line',
    description: 'K-POP 最新回归、打歌舞台与偶像动态',
    color: 'accent',
  },
  {
    slug: 'jpop',
    name: 'J-POP',
    icon: 'ri-headphone-line',
    description: 'J-POP 新曲速递、演唱会资讯与歌手专访',
    color: 'secondary',
  },
  {
    slug: 'variety',
    name: '日韩综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门日韩综艺节目推荐、名场面与嘉宾动态',
    color: 'primary',
  },
  {
    slug: 'star',
    name: '明星动态',
    icon: 'ri-star-line',
    description: '日韩明星最新消息、街拍时尚与社交媒体更新',
    color: 'accent',
  },
];

export const mockArticles = [
  {
    id: '1',
    title: '2026年夏季日剧推荐：十部必追神作盘点',
    slug: '2026-summer-japan-drama-top10',
    excerpt: '炎炎夏日，窝在空调房里追剧绝对是人生一大乐事。本期为大家精心挑选了2026年夏季档最值得期待的十部日剧，从悬疑推理到治愈温情，总有一部适合你。',
    content: `<p>炎炎夏日，窝在空调房里追剧绝对是人生一大乐事。本期为大家精心挑选了2026年夏季档最值得期待的十部日剧，从悬疑推理到治愈温情，总有一部适合你。</p>
<h2>1. 《深夜的检察官》</h2>
<p>由人气演员山崎贤人主演的法律悬疑剧，讲述一位年轻检察官在深夜处理特殊案件的故事。每集独立的案件背后，都隐藏着对社会现实的深刻思考。导演是曾执导《Legal High》的石川淳一，节奏紧凑，演技在线。</p>
<h2>2. 《夏日烟火与你》</h2>
<p>纯爱剧女王有村架纯的最新作品，讲述在镰仓夏日祭上邂逅的两位年轻人，跨越十年的爱情故事。画面唯美，配乐由知名作曲家菅野洋子操刀，每一帧都可以截图当壁纸。</p>
<h2>3. 《异世界料理人》</h2>
<p>改编自同名轻小说的奇幻美食剧。现代日本厨师穿越到异世界，用平凡食材创造令人惊叹的料理。特效精良，美食镜头让人垂涎欲滴，是一部治愈系佳作。</p>
<p>更多精彩日剧推荐，请持续关注aaa一级日韩的每日更新。</p>`,
    category: 'japan-drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20summer%20drama%20scene%20with%20warm%20evening%20light%2C%20modern%20Tokyo%20cityscape%20background%2C%20cinematic%20composition%2C%20soft%20bokeh%20lights%2C%20nostalgic%20atmosphere%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography%20with%20muted%20warm%20tones&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '编辑小樱',
    publishedAt: '2026-08-01',
    readTime: '8分钟',
    featured: true,
    views: 12800,
  },
  {
    id: '2',
    title: 'K-POP八月回归大战：谁将成为夏日音源王者',
    slug: 'kpop-august-comeback-2026',
    excerpt: '八月K-POP乐坛迎来超豪华回归阵容，BLACKPINK、SEVENTEEN、aespa等多组顶流团体正面对决。谁能在音源榜上拔得头筹？最新战况分析来了。',
    content: `<p>八月K-POP乐坛迎来超豪华回归阵容，BLACKPINK、SEVENTEEN、aespa等多组顶流团体正面对决。谁能在音源榜上拔得头筹？最新战况分析来了。</p>
<h2>回归时间线</h2>
<p>8月4日 - BLACKPINK 携新专辑《THE ALBUM 2》正式回归，主打曲《Neon Lights》发布即登顶Melon实时榜。</p>
<p>8月11日 - SEVENTEEN 迷你专辑《夏日狂想曲》上线，主打曲《Tidal Wave》以清凉夏日风席卷各大榜单。</p>
<p>8月18日 - aespa 带着充满未来感的《HYPER REALITY》回归，AI概念再次升级。</p>
<h2>音源战况</h2>
<p>目前BLACKPINK以微弱优势领跑，但SEVENTEEN和aespa的差距正在缩小。这场夏日音源大战远未结束，让我们拭目以待。</p>`,
    category: 'kpop',
    coverImage: 'https://readdy.ai/api/search-image?query=K-pop%20concert%20stage%20with%20vibrant%20neon%20lights%20and%20energetic%20atmosphere%2C%20modern%20Korean%20music%20performance%20scene%2C%20colorful%20stage%20lighting%2C%20dynamic%20composition%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography%20with%20warm%20tones&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '编辑智恩',
    publishedAt: '2026-08-03',
    readTime: '6分钟',
    featured: true,
    views: 15600,
  },
  {
    id: '3',
    title: '韩国电影《首尔之夜》横扫国际电影节，导演专访深度解读',
    slug: 'seoul-night-film-festival-2026',
    excerpt: '韩国导演朴赞郁新作《首尔之夜》在戛纳电影节斩获最佳导演奖，成为今年最受瞩目的亚洲电影。我们独家专访了朴导演，听他讲述创作背后的故事。',
    content: `<p>韩国导演朴赞郁新作《首尔之夜》在戛纳电影节斩获最佳导演奖，成为今年最受瞩目的亚洲电影。我们独家专访了朴导演，听他讲述创作背后的故事。</p>
<h2>关于电影</h2>
<p>《首尔之夜》讲述了一个发生在首尔江南区的悬疑故事，融合了黑色电影元素与韩国独特的社会议题。影片由宋康昊、金泰梨主演，摄影由《寄生虫》摄影师洪坰杓掌镜。</p>
<h2>导演访谈精选</h2>
<p><strong>问：这部电影的灵感来源是什么？</strong></p>
<p>朴赞郁：我在深夜开车经过江南时，看到那些闪烁的霓虹灯下隐藏的暗巷，突然想到——这座城市最光鲜亮丽的表面之下，有多少不为人知的故事？</p>
<p><strong>问：与宋康昊再次合作的感受？</strong></p>
<p>朴赞郁：康昊哥是那种能让任何角色活起来的演员。这次的角色与他以往塑造的形象完全不同，但他的表现令人震撼。</p>`,
    category: 'korea-movie',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20film%20noir%20cinematic%20scene%20with%20Seoul%20night%20cityscape%2C%20neon%20signs%20reflecting%20on%20wet%20streets%2C%20mysterious%20atmosphere%2C%20film%20grain%20texture%2C%20dark%20moody%20lighting%2C%20editorial%20photography%20with%20deep%20shadows&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '编辑俊昊',
    publishedAt: '2026-08-02',
    readTime: '10分钟',
    featured: true,
    views: 9800,
  },
  {
    id: '4',
    title: '日韩综艺大对决：Running Man vs VS岚，谁是你的周末快乐源泉',
    slug: 'japan-korea-variety-show-comparison',
    excerpt: 'Running Man和VS岚作为日韩两国最长寿的综艺节目，各自拥有一批忠实粉丝。本期我们来一场全方位的对比分析，看看哪档节目更值得你周末追看。',
    content: `<p>Running Man和VS岚作为日韩两国最长寿的综艺节目，各自拥有一批忠实粉丝。本期我们来一场全方位的对比分析。</p>
<h2>Running Man：十四年长青的秘诀</h2>
<p>自2010年开播以来，Running Man以其独特的撕名牌环节和成员间的化学反应俘获了全球观众。刘在石、金钟国、宋智孝等固定成员的默契配合，加上每期不同的主题和嘉宾，让节目保持新鲜感。</p>
<h2>VS岚：五人五色的魅力</h2>
<p>岚的五位成员——大野智、樱井翔、相叶雅纪、二宫和也、松本润，在节目中展现了各自独特的个性和才能。游戏环节设计巧妙，从体力对决到智力比拼，每一期都充满笑点。</p>
<h2>终极对决</h2>
<p>如果你喜欢激烈刺激的游戏和跑酷元素，Running Man更适合你；如果你偏爱温馨搞笑的氛围和多样的游戏设计，VS岚不容错过。当然——为什么不能两档都追呢？</p>`,
    category: 'variety',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20and%20Korean%20variety%20show%20studio%20set%20with%20colorful%20decorations%2C%20bright%20studio%20lighting%2C%20playful%20atmosphere%2C%20game%20show%20elements%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography%20with%20warm%20tones&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '编辑小樱',
    publishedAt: '2026-07-30',
    readTime: '7分钟',
    featured: false,
    views: 7200,
  },
  {
    id: '5',
    title: '新海诚最新动画电影《星之彼方》预告发布，2027年上映确定',
    slug: 'shinkai-new-film-star-beyond-2027',
    excerpt: '日本动画大师新海诚时隔三年带来全新力作《星之彼方》，首支预告片画面绝美，讲述了一段跨越星际的青春物语。',
    content: `<p>日本动画大师新海诚时隔三年带来全新力作《星之彼方》，首支预告片画面绝美，讲述了一段跨越星际的青春物语。</p>
<h2>故事简介</h2>
<p>故事发生在近未来的日本，高中生星空遥在一次天文观测中意外接收到来自宇宙的神秘信号。为了解开信号背后的秘密，她踏上了一段跨越星际的奇妙旅程。</p>
<h2>制作团队</h2>
<p>本片由新海诚亲自担任导演、编剧和分镜，角色设计由田中将贺负责，音乐继续由RADWIMPS操刀。制作方表示，本片将是新海诚迄今为止制作规模最大的作品。</p>
<h2>上映信息</h2>
<p>《星之彼方》预计于2027年夏季在日本上映，全球发行计划也在同步推进中。对于热爱新海诚作品的观众来说，这无疑是未来一年最值得期待的动画电影之一。</p>`,
    category: 'japan-movie',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20film%20scene%20with%20starry%20night%20sky%20and%20floating%20islands%2C%20ethereal%20celestial%20atmosphere%2C%20soft%20pastel%20colors%2C%20dreamy%20clouds%2C%20cinematic%20composition%2C%20clean%20minimal%20aesthetic&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '编辑健太',
    publishedAt: '2026-07-28',
    readTime: '5分钟',
    featured: false,
    views: 18500,
  },
  {
    id: '6',
    title: 'J-POP夏季音乐节全攻略：Fuji Rock、Summer Sonic看点前瞻',
    slug: 'jpop-summer-festival-2026-guide',
    excerpt: '日本夏季两大音乐节Fuji Rock和Summer Sonic即将在八月拉开帷幕。本届阵容豪华，包括Official髭男dism、YOASOBI、米津玄师等顶级艺人。',
    content: `<p>日本夏季两大音乐节Fuji Rock和Summer Sonic即将在八月拉开帷幕。本届阵容豪华，包括Official髭男dism、YOASOBI、米津玄师等顶级艺人。</p>
<h2>Fuji Rock Festival 2026</h2>
<p>时间：8月15日-17日</p>
<p>地点：新潟县苗场滑雪场</p>
<p>亮点阵容：Official髭男dism、King Gnu、millennium parade、星野源</p>
<p>作为亚洲最大的户外音乐节，Fuji Rock以其绝美的自然环境和顶级的音响设备闻名。今年的阵容特别强化了日本本土艺人的比例。</p>
<h2>Summer Sonic 2026</h2>
<p>时间：8月16日-17日</p>
<p>地点：千叶 & 大阪（双城联动）</p>
<p>亮点阵容：YOASOBI、米津玄师、Ado、Vaundy</p>
<p>Summer Sonic主打都市音乐节概念，舞台设置更加紧凑，方便观众快速切换不同演出。</p>`,
    category: 'jpop',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20summer%20music%20festival%20outdoor%20scene%20with%20large%20stage%20and%20crowd%2C%20mountain%20background%2C%20golden%20hour%20lighting%2C%20festival%20flags%20and%20banners%2C%20vibrant%20atmosphere%2C%20clean%20minimal%20aesthetic&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '编辑智恩',
    publishedAt: '2026-07-25',
    readTime: '6分钟',
    featured: false,
    views: 6200,
  },
  {
    id: '7',
    title: '韩剧《财阀家的小儿子》第二季确认制作，原班人马回归',
    slug: 'chaebol-family-son-season2-confirmed',
    excerpt: '大热韩剧《财阀家的小儿子》第二季正式确认制作！宋仲基、李星民等原班人马悉数回归，编剧金泰姬将继续执笔。',
    content: `<p>大热韩剧《财阀家的小儿子》第二季正式确认制作！宋仲基、李星民等原班人马悉数回归，编剧金泰姬将继续执笔。</p>
<h2>制作确认</h2>
<p>JTBC官方于8月4日正式宣布《财阀家的小儿子》第二季进入前期筹备阶段。第一季以26.9%的最高收视率创下韩国有线电视历史纪录，第二季备受期待。</p>
<h2>剧情展望</h2>
<p>据编剧透露，第二季将聚焦陈导俊接管顺洋集团后的故事，财阀家族内部权力斗争将进一步升级。同时，第一季结尾留下的悬念——陈导俊的真实身份之谜——也将在新季中揭晓。</p>
<h2>播出时间</h2>
<p>预计2027年上半年在JTBC播出，具体日期尚未确定。aaa一级日韩将持续关注最新动态。</p>`,
    category: 'korea-drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20luxury%20office%20scene%20with%20modern%20Seoul%20skyline%20view%2C%20sleek%20corporate%20interior%2C%20dramatic%20lighting%2C%20high-end%20aesthetic%2C%20clean%20minimal%20composition%2C%20editorial%20photography%20with%20warm%20undertones&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '编辑俊昊',
    publishedAt: '2026-08-04',
    readTime: '5分钟',
    featured: false,
    views: 22000,
  },
  {
    id: '8',
    title: '日本电影学院奖完整获奖名单，《哥斯拉-1.0》成最大赢家',
    slug: 'japan-academy-awards-2026-winners',
    excerpt: '第49届日本电影学院奖颁奖典礼在东京圆满落幕，《哥斯拉-1.0》包揽最佳影片、最佳导演等八项大奖，成为当晚最大赢家。',
    content: `<p>第49届日本电影学院奖颁奖典礼在东京圆满落幕，《哥斯拉-1.0》包揽最佳影片、最佳导演等八项大奖，成为当晚最大赢家。</p>
<h2>主要获奖名单</h2>
<ul>
<li>最佳影片：《哥斯拉-1.0》</li>
<li>最佳导演：山崎贵（《哥斯拉-1.0》）</li>
<li>最佳男主角：役所广司（《完美的日子》）</li>
<li>最佳女主角：安藤樱（《怪物》）</li>
<li>最佳男配角：矶村勇斗（《月》）</li>
<li>最佳女配角：广濑铃（《哥斯拉-1.0》）</li>
<li>最佳动画：《你想活出怎样的人生》</li>
</ul>
<p>aaa一级日韩恭喜所有获奖者，期待日本电影继续为全球观众带来更多佳作。</p>`,
    category: 'japan-movie',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20film%20awards%20ceremony%20stage%20with%20golden%20trophy%20and%20spotlights%2C%20elegant%20red%20carpet%2C%20prestigious%20atmosphere%2C%20theater%20interior%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '编辑健太',
    publishedAt: '2026-07-22',
    readTime: '4分钟',
    featured: false,
    views: 4500,
  },
];